import styled, { css } from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

import { Indicator } from 'legacyComponents/styled/lib';
import Image from 'components/Image';
import Banner from 'components/Banner';

export const Article = styled.div`
  margin: ${props => (props.increasedMargin ? '90px auto 0' : '30px auto 0')};
  width: 92vw;
  max-width: 700px;
`;

export const Title = styled.h1`
  margin: 30px 0 5px;
  font-size: 1.75em;
  line-height: 1.4;
  ${media.s`
    margin: 15px 0 5px;
    font-size: 1.3em;
  `};
`;

export const AvatarIndicator = styled(Indicator)`
  width: 100%;
  height: 380px;
  margin: ${props => props.theme.spacing.large} auto 0;
  ${media.l`
    height: 360px;
  `};
  ${media.m`
    height: 340px;
  `};
  ${media.s`
    height: 275px;
  `};
  ${media.xs`
    height: 200px;
  `};
`;

export const TitleIndicator = styled(Indicator)`
  margin: 30px 0 10px;
  height: 36px;
  width: 80%;
  ${media.s`
    margin: 20px 0 10px;
    height: 32px;
  `};
`;

export const InfoIndicator = styled(Indicator)`
  margin: 0 0 20px;
  height: 20px;
  width: 25%;
  ${media.s`
    height: 16px;
  `};
`;

export const StoryWrapper = styled.article`
  display: block;
  margin: ${props => (props.margin ? props.margin : '30px auto')};
  width: 700px;
  height: auto;
  line-height: 1.6;
  font-size: 19px;
  margin-bottom: 30px;
  color: ${props => props.theme.color.wfBlack};
  ${media.s`
    width: 610px;
    font-size: 16px;
    margin-bottom: 15px;
  `};
  ${media.xs`
    width: 100%;
  `};
`;

export const TagsWrapper = styled.div`
  display: block;
  margin: ${props => (props.margin ? props.margin : '0 auto')};
  width: 700px;
`;

const imageRatio = [2400, 760];
const getHeight = width =>
  `calc(${imageRatio[1]} * ${width} / ${imageRatio[0]})`;
const maxWidth = '1000px';

const storyImageSize = css`
  width: 92vw;
  height: ${getHeight('92vw')};
  max-width: ${maxWidth};
  max-height: ${getHeight(maxWidth)};
`;

export const BannerStyled = styled(Banner)`
  max-width: ${props =>
    `calc(${props.theme.layout.maxWidth} - calc(${props.theme.layout.paddingInline} * 2))`};
  margin: ${props => props.theme.spacing.large} auto 0;
  ${media.l`
    width: 1100px;
  `};
  ${media.m`
    width: 780px;
  `};
  ${media.s`
    width: 630px;
  `};
  ${media.xs`
    width: calc(100% - 30px);
  `};
`;

export const CoverImage = styled(Image)`
  ${storyImageSize}
  margin: ${props => props.theme.spacing.xxlarge} auto 0;
`;

export const CoverImageCropper = styled.div`
  ${storyImageSize}
  margin: ${props => props.theme.spacing.large} auto 0;
  border: 1px solid ${props => props.theme.color.wfGrey300};
  & div.cropper {
    ${storyImageSize}
  }
`;

export const TitleInput = styled.div`
  > textarea {
    color: ${props => props.theme.color.wfBlack};
    font-size: 1.75em;
    resize: none;
    font-weight: 600;
    min-height: 40px;
    padding: 0;
    &::placeholder {
      font-weight: 600;
    }
    ${media.s`
      font-size: 1.3em;
    `};
  }
  border: none;
  width: 100%;
  position: relative;
`;

export const BodyInput = styled.div`
  border: none;
  width: 100%;
  min-height: 300px;
`;

export const TagsWrapperNonEdidMode = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 92vw;
  margin-left: auto;
  margin-right: auto;
  margin-top: ${props => props.theme.spacing.xlarge};

  ${media.s`
    margin-top: 0px;
  `};
`;

export const CenterWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
